import {
	type BlokProps,
	StoryblokComponent,
	StoryblokComponentList,
} from "@trydig/storyblok";
import { Hero4Skeleton } from "@/components/ui/Hero/Hero4";
import type { BlokArticlePage } from "@/storyblok";
import { ArticleCreditsBlok } from "../ArticleCreditsBlok";
import BlokWrap from "../BlokWrap";
import type { AllBloks } from "../defineBloks";
import styles from "./ArticlePageBlok.module.css";

export const ArticlePageBlok = ({
	blok,
	preview,
	tags,
}: BlokProps<BlokArticlePage> & {
	tags?: string[];
}) => {
	const intro = blok.intro?.at(0);
	const credits = blok.credits?.at(0);

	return (
		<BlokWrap editable={blok} asChild>
			<main
				className={styles.root}
				style={
					{
						"--background-color": (intro?.background as { value?: string })
							?.value,
					} as React.CSSProperties
				}
			>
				{intro && (
					<StoryblokComponent
						tag={tags?.[0]?.toUpperCase()}
						blok={intro}
						preview={preview}
					/>
				)}

				<div className={styles.intro}>
					{credits && <ArticleCreditsBlok blok={credits} preview={preview} />}
				</div>

				{blok.body && blok.body.length > 0 && (
					<div className={styles.body}>
						<StoryblokComponentList
							bloks={blok.body as AllBloks[]}
							preview={preview}
						/>
					</div>
				)}
			</main>
		</BlokWrap>
	);
};

export const ArticlePageBlokSkeleton = () => {
	return (
		<div className={styles.root}>
			<Hero4Skeleton />
		</div>
	);
};
